import Cookies from 'universal-cookie';
import { COOKIE_NAMES } from 'lib/enums/cookies';

const getHashedQFF = (): string | null => {
  const cookies = new Cookies();
  return cookies.get(COOKIE_NAMES.QF_VALUE) || null;
};

export default getHashedQFF;
